<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Basi"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="9">
              <span class='label'>
                Base
              </span>
            </b-col>
            <b-col cols="3">
              <span class='label'>
                Voce
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="9">
              <b-form-input v-model="selectedBase.base_code" class=""></b-form-input>
            </b-col>
            <b-col cols="3">
              <select class="custom-select" v-model="base_code" @change="addTag">
                <option value="" disabled>Seleziona le voci</option>
                <option v-for="voice in voices" :key="voice.id" :value="voice.id">
                  {{ voice.voice_name }}
                </option>
              </select>
            </b-col>
            <b-col cols="4">
              <b-form-tags
                :key="voices_selected.length"
                input-id="tags-voices"
                v-model="voices_selected"
                separator=" ,;"
                placeholder=""
                @tag-state="onVoiceState"
                tag-variant="primary"
                tag-pills
                style="border: 0;"
              >            
                <template #tag="{ tag, tagClass, removeTag }">
                  <span :class="tagClass" style="background-color: blue; color: white; padding: 0.25rem 0.5rem; border-radius: 8px;margin-right: 0.3rem;">
                    {{ formatTag(tag) }}
                    <b-button
                      size="sm"
                      @click="removeTag"
                      aria-label="Remove tag"
                      style="background-color: blue; color: white; border: none;"
                    >×</b-button>
                  </span>
                </template>
              </b-form-tags>
            </b-col>
          </b-row>            

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelBase">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertBase">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateBase">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Basi"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <table class="" :key="paginatedBases.length">
                <thead>
                  <tr>
                    <th style="width: 0%;"></th>
                    <th style="width: 65%;">Base</th>
                    <th style="width: 30%;">Lista voci</th>
                    <th style="width: 5%;"></th>
                  </tr>
                </thead>
                <tbody>                  
                  <tr v-for="base in paginatedBases" :key="base.id" class="row-selection">
                    <td @click="editRow(base)" style="visibility: hidden;">{{ base.id }}</td>
                    <td @click="editRow(base)">{{ base.base_code }}</td>
                    <td @click="editRow(base)">
                      {{ formattedVoices(base.voices_list) }}
                      <span v-if="base.voices_list">
                        <br>
                        <small v-if="!Array.isArray(base.voices_list)">
                          voices_list is not an array: {{ base.voices_list }}
                        </small>
                      </span>
                    </td>
                    <td>
                      <i
                        class="fas fa-trash"
                        @click="deleteRecord(base.id)"
                        style="pointer: cursor !important;"
                      ></i>
                    </td>
                  </tr>                
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
                @change="onPageChange"
                class="my-3"
              ></b-pagination>            
            </b-col>
            <b-col cols="2">
              <span>Pagina {{ currentPage }} di {{ totalPages }} pagine</span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>


</div>